<template>
  <div class="store-vs-store">
    <div class="header">
      <h3>Store Totals</h3>
      <div class="toggle">
        <button :class="{ active: dataType === 'sales' }" @click="setDataType('sales')">Sales</button>
        <button :class="{ active: dataType === 'count' }" @click="setDataType('count')">Count</button>
      </div>
    </div>
    <p v-if="loading" class="loading">Loading...</p>
    <table v-else class="totals-table">
      <tbody>
        <tr v-for="store in stores" :key="store.site">
          <td class="store-name">{{ store.site }}</td>
          <td>
            <span v-if="dataType === 'count'">{{ store.total }}</span>
            <CurrencyFormatter v-else :value="store.total" :currency="currency" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import { CurrencyFormatter } from "@monolith/components";

export default {
  name: "StoreVsStore",
  components: { CurrencyFormatter },
  data() {
    return {
      stores: [],
      loading: true,
      dataType: "sales",
    };
  },
  computed: {
    ...mapGetters({ currency: "currency" }),
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async setDataType(type) {
      this.dataType = type;
      await this.loadData();
    },
    async loadData() {
      this.loading = true;
      const sites = JSON.parse(localStorage.getItem("sites") || "[]");
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setHours(23, 59, 59, 0);
      const startStr = start.toISOString().substring(0, 13);
      const endStr = end.toISOString().substring(0, 13);

      const results = await Promise.all(
        sites.map(async (site) => {
          const rows = this.dataType === "sales"
            ? await api.get_sales_total(site, startStr, endStr)
            : await api.get_count_total(site, startStr, endStr);
          const total = rows.length > 0 ? rows[0].value : 0;
          return { site, total };
        })
      );

      this.stores = results;
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.store-vs-store {
  padding: 1rem;
  background-color: var(--secondary-colour);
  border-radius: 1rem;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75rem;

    h3 {
      margin: 0;
    }

    .toggle {
      display: flex;
      gap: 0.5rem;

      button {
        padding: 0.3rem 0.8rem;
        border: 1px solid var(--primary-colour, #3bafda);
        border-radius: 0.4rem;
        background: transparent;
        cursor: pointer;
        font-size: 0.9rem;

        &.active {
          background: var(--primary-colour, #3bafda);
          color: white;
        }
      }
    }
  }

  .loading {
    color: var(--text-muted, #888);
  }

  .totals-table {
    width: 100%;
    border-collapse: collapse;

    tr {
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);

      &:last-child {
        border-bottom: none;
        font-weight: bold;
      }
    }

    td {
      padding: 0.4rem 0.5rem;

      &.store-name {
        text-transform: capitalize;
      }

      &:last-child {
        text-align: right;
      }
    }
  }
}
</style>
